import React from "react";
import styled from "styled-components";

export default styled.span`
    color: #A4A6B9;
    font-size: 16px;;
`;